import React, {
  DetailedHTMLProps,
  FunctionComponent,
  LinkHTMLAttributes,
} from 'react';
import Helmet from 'react-helmet';
import { pure } from 'recompose';
import { ResolvedUrls } from '../utils/resolver';
import { CdnUrlProvider } from './Cdn/CdnUrlProvider';

// Webfonts required by ZUI Typography
const fontUrls = [
  'fonts/roboto_regular_macroman/Roboto-Regular-webfont.woff',
  'fonts/roboto_italic_macroman/Roboto-Italic-webfont.woff',
  'fonts/roboto_medium_macroman/Roboto-Medium-webfont.woff',
  'fonts/roboto_bold_macroman/Roboto-Bold-webfont.woff',
];

// This is for helmet's link property
type LinkType = DetailedHTMLProps<
  LinkHTMLAttributes<HTMLLinkElement>,
  HTMLLinkElement
>;

/**
 * Create array of font files/css urls that should be loaded on the page
 */
const getLinks = (cdnUrls: ResolvedUrls): LinkType[] => {
  const fontsFiles = fontUrls.map(fontUrl => {
    return {
      key: fontUrl,
      rel: 'preload',
      href: new URL(fontUrl, cdnUrls.zenoCdn).toString(),
      as: 'font',
      crossOrigin: 'anonymous',
    } as LinkType;
  });

  const fontCss = [cdnUrls.robotoUrl, cdnUrls.robotoCondensedUrl].map(
    fontUrl => {
      return {
        key: fontUrl,
        href: fontUrl,
        type: 'text/css',
        crossOrigin: 'anonymous',
      } as LinkType;
    },
  );
  return [...fontsFiles, ...fontCss];
};

const AssetsBase: FunctionComponent = () => {
  return (
    <CdnUrlProvider.Consumer>
      {cdnUrls => <Helmet link={getLinks(cdnUrls)} />}
    </CdnUrlProvider.Consumer>
  );
};

/**
 * Load assets (e.g. font files/css) via React Helmet
 * @see https://github.com/nfl/react-helmet
 */
export const Assets = pure(AssetsBase);

Assets.displayName = 'Assets';
